import { render, staticRenderFns } from "./itemTable.vue?vue&type=template&id=e09b0b82&class=crud-item-grid"
import script from "./itemTable.ts?vue&type=script&lang=js&external"
export * from "./itemTable.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e09b0b82')) {
      api.createRecord('e09b0b82', component.options)
    } else {
      api.reload('e09b0b82', component.options)
    }
    module.hot.accept("./itemTable.vue?vue&type=template&id=e09b0b82&class=crud-item-grid", function () {
      api.rerender('e09b0b82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/manipulacao/itemTable.vue"
export default component.exports